module.exports = __webpack_public_path__ + "img/credit-card.6b1cc2ac.svg";